import { ColumnDef } from '@tanstack/react-table'
import { GetDynamicPageDataResponse } from '@/modules/client-setting/type'
import EditDynamicPageModal from './components/EditDynamicPageModal'
import { Link } from 'react-router-dom'
import { Button } from '@/common/ui/button'
import DeleteDynamicPageModal from './components/DeleteDynamicPage'
import { Badge } from '@/common/ui/badge'

export const columns: ColumnDef<GetDynamicPageDataResponse>[] = [
	{
		accessorKey: 'name',
		header: 'ชื่อ',
		cell: ({ row }) => (
			<div className="flex items-center gap-2">
				<span>{row.original.name}</span>
				<EditDynamicPageModal
					id={row.original.id}
					defaultName={row.original.name}
				/>
			</div>
		),
	},
	{
		accessorKey: 'status',
		header: 'สถานะ',
		cell: ({ row }) => (
			<Badge variant={row.original.isActive ? 'default' : 'secondary'}>
				{row.original.isActive ? 'ใช้งาน' : 'ปิดใช้งาน'}
			</Badge>
		),
	},
	{
		accessorKey: 'delete',
		header: 'ลบ',
		cell: ({ row }) => <DeleteDynamicPageModal id={row.original.id} />,
	},
	{
		id: 'action',
		header: 'ดูรายละเอียด',
		cell: ({ row }) => (
			<Link to={`/operator/dynamic-page/${row.original.id}`}>
				<Button variant="outline">ดูรายละเอียด</Button>
			</Link>
		),
	},
	{
		accessorKey: 'createdAt',
		header: 'วันที่สร้าง',
		cell: ({ row }) => new Date(row.original.createdAt).toLocaleString(),
	},
	{
		accessorKey: 'updatedAt',
		header: 'วันที่แก้ไข',
		cell: ({ row }) =>
			row.original.updatedAt
				? new Date(row.original.updatedAt).toLocaleString()
				: '-',
	},
]
